module.exports = __webpack_public_path__ + "static/media/fail.adcbbdd3.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/fail.gif
// module id = 636
// module chunks = 0